import React, {Component, ReactNode} from 'react'
import {AssocOfCondominium} from '../model/AssocOfCondominium'
import {Nullable, Optional} from '../../../app/TypeHelpers'
import moment, {Moment} from 'moment'
import {TableRowName} from '../../../styledComponents/adminPage/Table'
import PPInput from '../../shared/forms/PPInput'
import PPDatePicker from '../../shared/forms/PPDatePicker'
import PPErrorLabel from '../../shared/forms/PPErrorLabel'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {AssocTerm} from '../model/AssocTerm'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import {AssocItemName, AssocItemValue} from '../shared/AssocComponents'
import styled from 'styled-components'
import {LeftRowFlexContainer, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {PageMainArea} from '../../shared/hoc/withAdminPageTemplate'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material';

interface Props {
    condominiumCd: string,
    assocList: AssocOfCondominium[],
    selectedAssocId: number,
    baseAssocTerm?: AssocTerm,
    handleClickPreviousPage: () => void
    handleClickSubmit: (state: AdminAssocTermFormState) => void
    eventEmitter: EventEmitterExAdmin
}

export interface AdminAssocTermFormState {
    assocName: string
    assocTermName: string
    assocTermStartDate: Nullable<Moment>
    assocTermEndDate: Nullable<Moment>
}

export class AdminAssocTermForm extends Component<Props, AdminAssocTermFormState> {
    constructor(props: Readonly<Props>) {
        super(props)

        const {
            assocList,
            selectedAssocId,
            baseAssocTerm,
        } = this.props

        const selectedAssoc = assocList.find(assoc => assoc.assocId === selectedAssocId)
        if (!selectedAssoc) {
            throw Error('選択された管理組合がリストにない')
        }

        if (baseAssocTerm) {
            this.state = {
                assocName: selectedAssoc.assocName,
                assocTermName: baseAssocTerm.assocTermName,
                assocTermStartDate: baseAssocTerm.assocTermStartDate,
                assocTermEndDate: baseAssocTerm.assocTermEndDate,
            }
        } else {
            this.state = {
                assocName: selectedAssoc.assocName,
                assocTermName: '',
                assocTermStartDate: null,
                assocTermEndDate: null,
            }
        }
    }

    handleChangeAssocTermName = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({assocTermName: event.target.value})
    }

    handleChangeAssocTermStartDate = (date: Nullable<Date>) => {
        const newAssocTermStartDate = date ? moment(date.toISOString()) : null
        this.setState({assocTermStartDate: newAssocTermStartDate})

        if(newAssocTermStartDate !== null && this.state.assocTermEndDate === null) {
            const autoInputAssocTermEndDate = newAssocTermStartDate.clone().add(1, 'year').endOf('month')
            this.setState({
                assocTermEndDate: autoInputAssocTermEndDate
            })
        }
    }

    handleChangeAssocTermEndDate = (date: Nullable<Date>) => {
        this.setState({assocTermEndDate: date ? moment(date.toISOString()) : null})
    }

    handleClickPreviousPage = () => {
        this.props.handleClickPreviousPage()
    }

    handleClickSubmit = () => {
        this.props.handleClickSubmit(this.state)
    }

    render(): ReactNode {
        const {
            assocList,
            eventEmitter
        } = this.props

        const {
            assocName,
            assocTermName,
            assocTermStartDate,
            assocTermEndDate,
        } = this.state


        const maxOfStartDate: Optional<Date> = assocTermEndDate?.clone().add(-1, 'd').toDate()
        const minOfEndDate: Optional<Date> = assocTermStartDate?.clone().add(1, 'd').toDate()

        const registerButtonDisabled = assocTermName === '' || assocTermStartDate === null || assocTermEndDate === null

        return <>
            <Box height={'9px'}/>
            {assocList.length >= 2 && <>
                <LeftRowFlexContainer>
                    <AssocItemName>管理組合</AssocItemName>
                    <AssocItemValue>{assocName}</AssocItemValue>
                </LeftRowFlexContainer>
                <Box height={'16px'}/>
            </>}
            <PageMainArea>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableRowName required>任期の名前</TableRowName>
                            <TableCell>
                                <TermNameInput
                                    inputProps={{
                                        maxLength: 30,
                                    }}
                                    eventEmitter={eventEmitter}
                                    eventKeys={['assocTermName']}
                                    onChange={this.handleChangeAssocTermName}
                                    value={assocTermName}
                                    placeholder={'例：第1期'}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>期間</TableRowName>
                            <TableCell>
                                <TermInputContainer style={{paddingBottom: 4, paddingTop: 8.2}}>
                                    <PPDatePicker
                                        onChangeDate={this.handleChangeAssocTermStartDate}
                                        value={assocTermStartDate?.toDate() ?? null}
                                        maxDate={maxOfStartDate}
                                    />
                                    <Box margin={'0 24px'}>〜</Box>
                                    <PPDatePicker
                                        onChangeDate={this.handleChangeAssocTermEndDate}
                                        value={assocTermEndDate?.toDate() ?? null}
                                        minDate={minOfEndDate}
                                    />
                                </TermInputContainer>
                                <PPErrorLabel
                                    eventEmitter={eventEmitter}
                                    eventKeys={['assocTermStartDate', 'assocTermEndDate']}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </PageMainArea>
            <Box height={'16px'}/>
            <RowFlexContainer>
                <BackLink onClick={this.handleClickPreviousPage}>
                    理事会の任期一覧に戻る
                </BackLink>
                <AdminPrimaryButton
                    onClick={this.handleClickSubmit}
                    disabled={registerButtonDisabled}
                >
                    登録する
                </AdminPrimaryButton>
            </RowFlexContainer>
        </>
    }
}

const TermNameInput = styled(PPInput)`
  width: 500px;
`

const TermInputContainer = styled(RowFlexContainer)`
  width: 462px;
`
